import CheckIcon from '@mui/icons-material/Check';
import React__default, { useId, useRef, useState, useLayoutEffect } from 'react';
import { flushSync } from 'react-dom';
import { Button } from '../../atoms/Button.js';
import { Callout } from '../../atoms/Callout.js';
import { TitleGroup } from '../../molecules/TitleGroup.js';
import { viewTransitionHelper } from '../../utils/viewTransitionHelper.js';
import './ConnectBankAccount.scss';

const ConnectBankAccount = ({ onConnectBank, isLoading, errorTitle, errorDescription, className, title, checkmarkList = ['$0 in fees'], description = clerqDescription, buttonText = 'Search for your bank', }) => {
    const uniqueId = useId();
    const isInitialMount = useRef(true);
    // Animate presence of error banner
    const [internalErrorTitle, setInternalErrorTitle] = useState(errorTitle);
    const [internalErrorDescription, setInternalErrorDescription] = useState(errorDescription);
    useLayoutEffect(() => {
        // Skip on initial mount
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        viewTransitionHelper({
            updateDOM: () => {
                flushSync(() => {
                    setInternalErrorTitle(errorTitle);
                    setInternalErrorDescription(errorDescription);
                });
            },
        });
    }, [errorTitle, errorDescription]);
    const hasError = !!(internalErrorTitle || internalErrorDescription);
    return (React__default.createElement(React__default.Fragment, null,
        hasError && (React__default.createElement(Callout, { variant: 'error', title: internalErrorTitle, message: internalErrorDescription, className: 'connect-bank-account-error--rev' })),
        React__default.createElement("div", { "data-rev-component": 'connect-bank-account', "data-rev-has-error": hasError, className: className, style: {
                viewTransitionName: `connect-bank-account-content-${uniqueId}`,
            } },
            title !== null && (React__default.createElement(TitleGroup, { className: 'connect-bank-title--rev', title: title ?? 'Connect your bank', level: 'subgroup' })),
            checkmarkList !== null && (React__default.createElement("ul", { className: 'connect-bank-account-summary-list--rev' }, checkmarkList.map((listItem, index) => (React__default.createElement("li", { key: `bank-list-item-${index}` },
                React__default.createElement(CheckIcon, { className: 'connect-bank-account-summary-list-icon--rev' }),
                ' ',
                listItem))))),
            React__default.createElement(Button, { variant: 'filled', size: 'medium', onPress: onConnectBank, isLoading: isLoading, className: 'connect-bank-account-button--rev', isDisabled: isLoading }, buttonText),
            description !== null && (React__default.createElement("p", { className: 'connect-bank-account-description--rev' }, description)))));
};
const clerqDescription = 'Bank payments are securely processed through Clerq and may take up to 2 business days to complete. Depending on processing time, fulfillment may be delayed by a few days. Only US based bank accounts are supported currently.';

export { ConnectBankAccount };
//# sourceMappingURL=ConnectBankAccount.js.map
